import { createSlice } from '@reduxjs/toolkit'
import { initialStudentRoomState } from '../initialState/studentRoom'
import {
  fetchStudentRoomsList,
  joinRoom,
  joinRoomByCode,
} from '../asyncThunks/studentRoom'

const studentRoomSlice = createSlice({
  name: 'studentRoom',
  initialState: initialStudentRoomState,
  reducers: {
    clearStudentRoom: (state) => {
      state.currentRoom = null
      state.error = null
    },
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudentRoomsList.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchStudentRoomsList.fulfilled, (state, action) => {
        state.isLoading = false
        state.rooms = action.payload
        state.error = null
      })
      .addCase(fetchStudentRoomsList.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
      .addCase(joinRoom.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(joinRoom.fulfilled, (state, action) => {
        state.isLoading = false
        state.currentRoom = action.payload
        state.error = null
      })
      .addCase(joinRoom.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
      .addCase(joinRoomByCode.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(joinRoomByCode.fulfilled, (state, action) => {
        state.isLoading = false
        if (action.payload.room) {
          const existingRoomIndex = state.rooms.findIndex(
            (room) => room.roomid === action.payload.room.roomid
          )
          if (existingRoomIndex >= 0) {
            state.rooms[existingRoomIndex] = action.payload.room
          } else {
            state.rooms.push(action.payload.room)
          }
          state.currentRoom = action.payload.room
        }
        state.error = null
      })
      .addCase(joinRoomByCode.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
  },
})

export const { clearStudentRoom, clearError } = studentRoomSlice.actions
export default studentRoomSlice.reducer
